import { render, staticRenderFns } from "./SelecionarDocumento.vue?vue&type=template&id=b1be1f18&scoped=true&"
import script from "./SelecionarDocumento.vue?vue&type=script&lang=js&"
export * from "./SelecionarDocumento.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarDocumento.vue?vue&type=style&index=0&id=b1be1f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1be1f18",
  null
  
)

export default component.exports